// extracted by mini-css-extract-plugin
module.exports = {"card":"ra-card-campaign_card__lxdZ5","card__content":"ra-card-campaign_card__content__nwXqd"};